import {Component} from '@angular/core'

@Component({
  selector: 'aku-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent {
}
